// extracted by mini-css-extract-plugin
module.exports = {"carousel-container":"styles_carousel-container__fSOrc"};